import React, { useState, MouseEvent } from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from '@printdeal/ui-library';

import { dispatchAccountEvent } from '../../../../../../helpers/dataLayerHelpers/accountDataLayerHelper';
import CancelLineItemModal from './CancelLineItemModal';

interface Props {
  orderId: string;
  lineItemIds?: string[];
  customLineItemIds?: string[];
}

const CancelLineItemButton = ({
  orderId,
  lineItemIds = [],
  customLineItemIds = [],
}: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpenModal = (event: MouseEvent) => {
    event.preventDefault();
    setIsModalOpen(true);
    dispatchAccountEvent('order_detail_interaction', 'open_modal_cancel_line_item');
  };

  const handleCloseModal = (eventName: string) => {
    setIsModalOpen(false);
    dispatchAccountEvent('order_detail_interaction', eventName);
  };

  return (
    <>
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <Link
        as="button"
        type="button"
        onClick={handleOpenModal}
        variant="secondary"
        data-cy="cancelLineItem"
        iconBefore="times"
        className="pd-text-xs"
      >
        <FormattedMessage
          id="account.order.orderline.cancel"
          defaultMessage="Cancel item"
        />
      </Link>
      {
        isModalOpen && (
          <CancelLineItemModal
            orderId={orderId}
            lineItemIds={lineItemIds}
            customLineItemIds={customLineItemIds}
            handleCloseModal={handleCloseModal}
          />
        )
      }
    </>
  );
};

export default CancelLineItemButton;
